import React, { Component } from "react";
import ChatBubbleButton from "@material-ui/icons/ChatBubbleOutline";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { connect } from "react-redux";

import Badge from "@material-ui/core/Badge";

class ChatIcon extends Component {
  render() {
    return (
      <Tooltip
        disableFocusListener
        title={`Chat`}
        classes={{ tooltip: "tooltip" }}
        enterDelay={100}
      >
        <IconButton
          className="badge-button"
          onClick={e => {
            if (this.props.chat_key || this.props.chatDone) {
              document
                .getElementById("chat-container")
                .classList.remove("minimizado");
            } else {
              this.props.handleClickChat(e);
            }
          }}
        >
          {this.props.messages > 0 ? (
            <Badge
              badgeContent={this.props.messages}
              color="secondary"
              className="badge badge-alert"
            >
              <ChatBubbleButton />
            </Badge>
          ) : (
            <ChatBubbleButton />
          )}
        </IconButton>
      </Tooltip>
    );
  }
}

const mapStateToProps = state => ({
  messages: state.messages.pendingMessages.length
});

export default connect(
  mapStateToProps,
  null
)(ChatIcon);



// WEBPACK FOOTER //
// ./src/components/ChatIcon/index.js